module.exports = __webpack_public_path__ + "static/media/flowers.e2df0d01.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/flowers.png
// module id = 35
// module chunks = 0